import {StringValidacao} from './string';
import {Construtor} from './construtor';
import {GrupoAcesso} from './grupo-acesso';

export class UsuarioGrupoAcesso implements Construtor<UsuarioGrupoAcesso> {

  public idUsuarioGrupoAcesso: number;
  public idUsuario: number;
  public grupoAcesso: GrupoAcesso;
  public selecionado: boolean;
  public alterado: boolean;

  constructor(object?: any) {
    this.grupoAcesso = new GrupoAcesso();
    if (object !== undefined) {

      if (object instanceof UsuarioGrupoAcesso) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      return this.modeloCompleto() ? this : null;
    }

    return this;
  }

  get obterIdUsuarioGrupoAcesso(): number {
    return this.idUsuarioGrupoAcesso;
  }

  set IdUsuarioGrupoAcesso(idUsuarioGrupoAcesso: any) {
    this.idUsuarioGrupoAcesso = idUsuarioGrupoAcesso;
  }

  get obterGrupoAcesso(): GrupoAcesso {
    return this.grupoAcesso;
  }

  set GrupoAcesso(grupoAcesso: any) {
    this.grupoAcesso = grupoAcesso;
  }

  get obterIdUsuario(): number {
    return this.idUsuario;
  }

  set IdUsuario(idUsuario: any) {
    this.idUsuario = idUsuario;
  }

  copyObject(usuarioGrupoAcesso: UsuarioGrupoAcesso): void {

    this.idUsuarioGrupoAcesso = usuarioGrupoAcesso.obterIdUsuarioGrupoAcesso;
    this.grupoAcesso = usuarioGrupoAcesso.obterGrupoAcesso;
    this.idUsuario = usuarioGrupoAcesso.obterIdUsuario;
  }

  parseFromJson(usuarioGrupoAcesso: any): void {

    this.IdUsuarioGrupoAcesso = usuarioGrupoAcesso.idUsuarioGrupoAcesso;
    this.GrupoAcesso = usuarioGrupoAcesso.grupoAcesso;
    this.IdUsuario = usuarioGrupoAcesso.idUsuario;

  }

  modeloCompleto(): boolean {
    return this.grupoAcesso !== undefined;
  }

  getNewInstance(object?: any): UsuarioGrupoAcesso {
    return new UsuarioGrupoAcesso(object);
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/usuario-grupo-acesso.ts